import { createVuexStore } from 'way2web-vuex-store';

export default { ...createVuexStore() };
